/**
 * @description Helper methods that can be used on entire application
 * All methods must start with "h" to identify that is a Helper method
 */
export default {

    /**
     * Retrieves "data" object from JWT
     * @param jwt Json Web Token
     */
    h_get_jwt_data: function (jwt) {
        let data = null;
        if (jwt) {
            const jwtSplited = jwt.split(".");
            if (jwtSplited.length == 3) {
                data = JSON.parse(atob(jwtSplited[1]));
            }
        }
        return data;
    },

    /**
     * Validates that jwt token is still valid
     */
    h_is_jwt_token_valid: function () {
        let authenticated = false;
        if (localStorage.getItem('authenticated')) {
            const expiration_token_time = localStorage.getItem('expiration_token_time');
            authenticated = Number(expiration_token_time) > (Date.now() / 1000);
        }
        return authenticated;
    },

    /**
     * Capitalizes the first letter of a word. Example: hello => Hello, true => True
     */
    h_capitalize: function (value) {
        return value != null ? String(value).charAt(0).toUpperCase() + String(value).slice(1) : '';
    },

    /**
     * Retrieves the first property value from an Object, 
     * examples: {"a":"1", "b":"2"} => "1", {"name":"jose", lastname:"perez", "age":17} => "jose"
     */
    h_get_first_property_value: function (object) {
        return object != null ? object[Object.keys(object)[0]] : '';
    }

}
